function LoginLoading() {
  return <div>We&apos;re working on logging you in, one moment!</div>;
}
export default LoginLoading;
